import React from "react";
import { Spin, Pagination } from "antd";
import config from "appConfig";

import styles from "./paginationAds.scss";
import {
  calculateTotalPagingCount,
  checkEmptyObject,
  isMobileScreen,
  scrollToTop
} from "../../../../services";
import MyAdsList from "../MyAdsList/MyAdsList";
import getWidthContext from "../../../../HOCs/getWidthContext";
import MyAdsFilter from "../MyAdsFilter/MyAdsFilter";
import Skeleton from "../../../../components/Skeleton";

function PaginationAds(props: any) {
  const {
    ads,
    handlePageChange,
    adCardProps,
    responsiveProps,
    gutter,
    AdCardComponent,
    emptyAdsText,
    width,
    paginationClassName,
    category
  } = props;
  const handlePageNumberChange = (page: any, pageSize: any) => {
    handlePageChange(page, pageSize);
    scrollToTop();
  };

  const isMobile = isMobileScreen(width);

  return checkEmptyObject(ads) ? (
    <React.Fragment>
      <MyAdsFilter {...props} />
      <MyAdsList
        ads={ads.data}
        responsiveProps={responsiveProps}
        adCardProps={{ ...adCardProps, isMobile }}
        gutter={gutter}
        AdCardComponent={AdCardComponent}
        emptyAdsText={emptyAdsText}
        // className={styles.adList}
        showGoogleAds={false} //Temporary disabled google ads
        category={category}
      />
      {ads.count > config.maxAdPerPage || ads.page > 1 ? (
        <Pagination
          total={calculateTotalPagingCount(ads.count, ads.page)}
          current={ads.page}
          pageSize={config.maxAdPerPage}
          onChange={handlePageNumberChange}
          className={`${styles.pagination} ${paginationClassName}`}
        />
      ) : null}
    </React.Fragment>
  ) : (
    <div className={styles.myAdsSkeletonWrapper}>
      <div className={styles.filtersSkeletonWrapper}>
        <Skeleton style={{ width: "20%", height: 20 }} />
        <Skeleton style={{ width: "60%", height: 20 }} />
      </div>
      <Skeleton className={styles.skeleton} />
      <Skeleton className={styles.skeleton} />
      <Skeleton className={styles.skeleton} />
      <Skeleton className={styles.skeleton} />
    </div>
  );
}

PaginationAds.defaultProps = {
  adCardProps: {},
  ads: {},
  responsiveProps: {},
  gutter: 0,
  emptyAdsText: undefined,
  paginationClassName: ""
};

export default getWidthContext(PaginationAds);



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/PaginationAds/index.tsx